var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero is-fullheight is-danger is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"title is-1"},[_vm._v("Page Not Found")]),_c('router-link',{staticClass:"button is-outlined is-danger is-inverted",attrs:{"to":"/"}},[_vm._v("Go home")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }